import React from "react";
import { useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import logo from "../assets/images/logo.png";
import { googleAuthConfig } from "../services/authService";

const Login = () => {
  const navigate = useNavigate();

  const handleGoogleLogin = () => {
    console.log("Google login clicked");
    const { client_id, redirect_uri, scope } = googleAuthConfig;

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}`;

    console.log("Auth URL:", authUrl);
    window.location.href = authUrl;
  };

  return (
    <div className="min-h-screen bg-dark-bg flex flex-col items-center justify-center p-4 sm:p-6">
      {/* App Info */}
      <div className="text-center mb-8 sm:mb-16 w-full max-w-md px-4">
        <div className="flex items-center justify-center gap-4 mb-8">
          <img src={logo} alt="Notui Logo" className="h-16 w-auto" />
          <h1 className="text-4xl sm:text-5xl font-bold text-white">Notui</h1>
        </div>
        <p className="text-gray-400 text-lg sm:text-xl leading-relaxed">
          Your AI study companion. Transform notes into knowledge with smart
          summaries, interactive chat, and personalized tests.
        </p>
      </div>

      {/* Login Section */}
      <div className="w-full max-w-[320px] sm:max-w-md px-4">
        <div className="space-y-4">
          <button
            onClick={handleGoogleLogin}
            className="w-full flex items-center justify-center gap-3 px-4 py-4 sm:py-3 border border-gray-700 rounded-xl sm:rounded-lg text-white hover:bg-dark-hover transition-colors text-base sm:text-lg"
          >
            <FcGoogle className="w-5 h-5 sm:w-6 sm:h-6" />
            <span>Sign in with Google</span>
          </button>
        </div>

        <p className="mt-6 sm:mt-8 text-center text-gray-500 text-xs sm:text-sm px-2">
          By signing in, you agree to our{" "}
          <a href="/terms" className="text-blue-500 hover:underline">
            Terms of Service
          </a>{" "}
          and{" "}
          <a href="/privacy" className="text-blue-500 hover:underline">
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};

export default Login;
